import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/mercedes.png";
import Imagen2 from "../../../images/modulo12/escuela.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[13];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo12.url}/cierre`,
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[13].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[13].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-4 p-md-3">
          <h2 className="mb-4">Camino a la igualdad</h2>

            <p>
              La <strong>educación</strong> ha ayudado mucho a mejorar la
              situación de las mujeres en la sociedad. En el siglo XIX, la
              escritora Mercedes Cabello dijo que las mujeres necesitaban una
              buena educación para conseguir un buen empleo. Así, podían tener
              un sueldo y ser independientes.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Hoy las niñas asisten a la escuela, pero muchas no terminan la
              secundaria. Otras niñas, además de ir a la escuela, tienen que
              ayudar con el trabajo de la casa. Las mujeres siguen siendo{" "}
              <strong>las más excluidas</strong> del sistema educativo peruano.
            </p>
            <p>
              Todos debemos preocuparnos porque las niñas vayan a la escuela,
              empiecen a tiempo su primaria y no repitan de grado. La{" "}
              <strong>igualdad</strong>{" "}
              nos beneficia a todos.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean en silencio el texto titulado Camino a la igualdad.
            Pregunte lo siguiente a partir de lo leído:
            <ul>
              <li>
                <i>
                  “¿Qué resulta fundamental para mejorar la situación de las
                  mujeres? (Posible respuesta: La educación). “¿Qué problemas
                  enfrentan las niñas que las colocan en desventaja en el
                  sistema educativo? (Posible respuesta: No terminan la
                  secundaria, realizan muchas labores en el hogar, empiezan la
                  escuela tarde, repiten el grado, etc.)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad señalando que, si bien en las últimas décadas la
            situación de las mujeres en el sistema educativo ha mejorado, esta
            todavía no es igual a la de los hombres. Conforme se va avanzando en
            los niveles educativos (desde la primaria hasta la educación
            superior), vemos que el porcentaje de mujeres se reduce.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
